import React, { memo } from 'react';
import {
  MousePointerClick,
  FileText,
  Palette,
  Code2,
  MessageSquare,
  Rocket
} from 'lucide-react';
import './Process.css';

const steps = [
  {
    icon: MousePointerClick,
    number: '01',
    title: 'Choose Your Package',
    description: 'Browse our four service packages and select the one that fits your business. Pick your tier — Basic, Standard, or Premium.',
    time: 'Minute 1',
    color: '#2dd4bf',
  },
  {
    icon: FileText,
    number: '02',
    title: 'Submit Your Details',
    description: 'Fill in a quick intake form with your business info, goals, and preferences. Pay your 50% deposit to lock in your spot.',
    time: 'Day 1',
    color: '#8b5cf6',
  },
  {
    icon: Palette,
    number: '03',
    title: 'Design & Branding',
    description: 'We craft your brand identity, select colors and fonts, and design your website layout. You get concepts to choose from.',
    time: 'Days 2–5',
    color: '#f59e0b',
  },
  {
    icon: Code2,
    number: '04',
    title: 'Build & Development',
    description: 'Your website gets built on a professional platform — mobile-friendly, fast, and optimized for search engines.',
    time: 'Days 5–14',
    color: '#ec4899',
  },
  {
    icon: MessageSquare,
    number: '05',
    title: 'Review & Revisions',
    description: 'You review the finished site and request changes. We refine until you love it — included in your revision rounds.',
    time: 'Days 14–18',
    color: '#06b6d4',
  },
  {
    icon: Rocket,
    number: '06',
    title: 'Launch & Go Live',
    description: 'We launch your site, connect your domain, and hand over the keys. Pay the remaining 50% and start winning customers.',
    time: 'Launch Day',
    color: '#22c55e',
  },
];

const Process = memo(() => {
  return (
    <section className="process section" id="process">
      <div className="container">
        <div className="process__header">
          <span className="section-label">How It Works</span>
          <h2 className="section-title">From click to launch.<br />Every step mapped out.</h2>
          <p className="section-subtitle">
            No surprises, no confusion. Here's exactly what happens from the moment you choose a package to the day your site goes live.
          </p>
        </div>

        <div className="process__timeline">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="process__step">
                <div className="process__step-card">
                  <div className="process__step-top">
                    <div className="process__step-time">{step.time}</div>
                    <span className="process__step-number">{step.number}</span>
                  </div>

                  <div
                    className="process__step-icon"
                    style={{ background: `${step.color}15`, color: step.color }}
                  >
                    <Icon size={22} />
                  </div>

                  <h3 className="process__step-title">{step.title}</h3>
                  <p className="process__step-desc">{step.description}</p>

                  <div className="process__step-progress">
                    <div
                      className="process__step-progress-fill"
                      style={{
                        background: step.color,
                        width: `${((index + 1) / steps.length) * 100}%`
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
});

export default Process;
